import { SnippetFolder } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

export const ProductVersionIcon = (props: SvgIconProps) => (<SnippetFolder {...props}/>);